import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Questions } from './scenes/Questions'
import { Results } from './scenes/Results'
import { NoResults } from './scenes/Results/components/NoResults'
import { Landing } from './scenes/Landing'

export const ProductSelector =() => {
  return (
    <>
      <Switch>
        <Route
          path='/product-selector'
          component={Landing}
          exact
        />

        <Route
          path='/product-selector/questions'
          component={Questions}
          exact
        />

        <Route
          path='/product-selector/results/:brand/:leakage/:sku'
          component={Results}
        />

        <Route
          path='/product-selector/no-results'
          component={NoResults}
        />

        <Redirect
          to='/product-selector'
        />
      </Switch>
    </>
  )
}
